import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoMessages = _resolveComponent("InfoMessages")!
  const _component_Charge = _resolveComponent("Charge")!
  const _component_Login = _resolveComponent("Login")!
  const _component_EntryDescription = _resolveComponent("EntryDescription")!
  const _component_CampaignDetailCards = _resolveComponent("CampaignDetailCards")!
  const _component_FooterDescription = _resolveComponent("FooterDescription")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("img", {
      src: _ctx.landingPageConfig.image_path,
      alt: "landingPageImage",
      class: "sm:w-6/12 sm:px-1 my-0 mx-auto"
    }, null, 8, _hoisted_1),
    _createVNode(_component_InfoMessages, { infoMessages: _ctx.infoMessages }, null, 8, ["infoMessages"]),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_Charge, { key: 0 }))
      : (_openBlock(), _createBlock(_component_Login, { key: 1 })),
    _createVNode(_component_EntryDescription),
    _createVNode(_component_CampaignDetailCards),
    _createVNode(_component_FooterDescription)
  ]))
}